import * as Noty from 'noty';

const formatText = (title: string, text: string) =>
    `<h6 style="color: #fff">${title}</h6><p style="color: #fff">${text}</p>`;

export class AlertUtils {
    static success(title: string, text: string, timeout?: number) {
        new Noty({
            type: 'success',
            layout: 'topRight',
            theme: 'nest',
            text: formatText(title, text),
            timeout: timeout || 5000,
            closeWith: ['click', 'button'],
        }).show();
    }

    static warning(title: string, text: string, timeout?: number) {
        new Noty({
            type: 'warning',
            layout: 'topRight',
            theme: 'nest',
            text: formatText(title, text),
            timeout: timeout || 10000,
            closeWith: ['click', 'button'],
        }).show();
    }

    static error(title: string, text: string, timeout?: number) {
        new Noty({
            type: 'error',
            layout: 'topRight',
            theme: 'nest',
            text: formatText(title, text),
            timeout: timeout || 10000,
            closeWith: ['click', 'button'],
        }).show();
    }
}
